import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotForm!: FormGroup;
  userid: any;
  isActive = false;
  disableButton = false;
  inputIsEmail = true;
  errMsg = ''
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private snackBar: MatSnackBar
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.forgotForm = this.formBuilder.group({
      resetValue: new FormControl('', [
        Validators.required,
        Validators.email,
        Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
      ]),
    });    
  }

  ngOnInit() {
    this.forgotForm.reset();
  }

  

  // Validate if given value is EMAIL or PHONE
  emailPhoneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const emailRegex: RegExp = /([a-z0-9_.-]+)@([da-z.-]+).([a-z.]{2,5})/;
      const phoneRegex: RegExp = /([0-9]{5,14})/;
      const isEmail = emailRegex.test(control.value);
      const isPhone = phoneRegex.test(control.value);
      // check if input is email or not
      this.inputIsEmail = isEmail ? true : false;
      return isEmail || isPhone ? null : { invalid: { value: control.value } };
    };
  }

  sendCode() {
    const preparedObj = {
      isEmailId: this.inputIsEmail,
      context: this.forgotForm.controls.resetValue.value,
    };
    this.disableButton = true;
    let path = 'send-otp';
    this.authService.resetObj = preparedObj;
    this.authService.send_code(path, preparedObj).subscribe(
      (res: any) => {
        this.authService.userResetInfo = preparedObj;
        this.snackBar.open('Authorization Code is sent to your registered Email', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
        this.router.navigate(['/auth-code', { userId: this.userid }]);
      },
      (error) => {
        console.log('error:', error);
        this.disableButton = false;
        // this.router.navigate(["/auth-code", { userId: this.userid }]);
        this.errMsg = error.error.message || 'Failed to send Email'
        this.forgotForm.get('resetValue')?.setErrors({notRegistered:true})
        // this.snackBar.open(error.error.message || 'Something went wrong', '', {
        //   duration: 2000,
        //   horizontalPosition: 'end',
        //   verticalPosition: 'bottom',
        // });
      }
    );
  }
}
